import tw from 'tailwind-styled-components'

const dialogPanel = `
w-full 
h-[350px]
lg:w-[1018px]
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`
export const Body=tw.div``

export const DataBox = tw.div`
mt-9
border
py-6
px-[18px]
border-solid 
border-gray-300
flex
gap-[36px]
`
export const ButtonsContainer = tw.div`
flex gap-4 mt-8
items-center
justify-center

`
const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
items-center
`

export { dialogPanel, dialogTitle }
